import { profileActionTypes } from "../actions/index";


export const initialState = {
    isLoad: false,
}

export const importReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileActionTypes.IMPORT:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}